import React from 'react';
import { useQuery } from '@apollo/client/react';
import { useParams } from 'react-router';
import { MainView } from '@repo/ui/Views';
import { FallbackCard } from '@repo/ui/Card';
import { useUser } from '@repo/hooks/useUser';

import { Authorization, POLICIES } from '@/lib/Authorization';
import { useAccount } from '@/hooks/useAccount';
import DIDS_SHOW_Q from '../gql/show.gql';
import DidTabNav from '../components/DidTabNav';
import ChangeDidApiKeyForm from '../components/ChangeDidApiKeyForm';
import ChangeDidSwitchForm from '../components/ChangeDidSwitchForm';

/** A number's API key and switch, each changeable. */
const DidUpdate = () => {
  const user = useUser();
  const { didId } = useParams();
  const accountId = useAccount().id;

  const { loading, data, refetch } = useQuery(DIDS_SHOW_Q, {
    variables: { id: String(didId) },
  });

  return (
    <MainView title={loading ? 'Loading...' : `Update: ${data?.did?.number}`} loading={loading}>
      <DidTabNav />
      <Authorization
        policyCheck={POLICIES['dids:update'](user)}
        fallbackView={
          <FallbackCard
            title="No access"
            description="You do not have permissions to update numbers."
          />
        }
      >
        {data?.did && (
          <div className="flex flex-col gap-6">
            <ChangeDidApiKeyForm didId={data.did.id} accountId={accountId} />
            <ChangeDidSwitchForm
              didId={data.did.id}
              accountId={accountId}
              currentSwitch={data.did.switch}
              refetch={refetch}
            />
          </div>
        )}
      </Authorization>
    </MainView>
  );
};

export default DidUpdate;
